import {Assignees} from './Assignees'
import {Development} from './Development'
import {Labels} from './Labels'
import {Reviewers} from './reviewers/Reviewers'
import {TeamReviewSummary} from './reviewers/TeamReviewSummary'
import {SidebarSection} from './SidebarSection'
import {SidebarActivity} from './activity/SidebarActivity'
import {ActivitySection} from './activity/ActivitySection'
import {OverviewMergeStatus} from '@github-ui/mergebox/mini-merge'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'

// NOTE: this Overview info only works on the /overview page due to how its
// wired up with dataload. This is an intentional tradeoff while deciding if its worth having
// this panel at all
export function OverviewInfoContent() {
  return (
    <ErrorBoundary boundaryName="OverviewInfoPanel">
      <Suspense fallback={<div>Loading...</div>}>
        <OverviewInfo />
      </Suspense>
    </ErrorBoundary>
  )
}

function OverviewInfo() {
  return (
    <div className="d-flex flex-column gap-3">
      <OverviewMergeStatus />

      <ActivitySection>
        <SidebarActivity />
      </ActivitySection>

      <SidebarSection title="Assignees">
        <Assignees />
      </SidebarSection>

      <SidebarSection title="Reviewers">
        <Reviewers />
      </SidebarSection>

      <TeamReviewSummary />

      <SidebarSection title="Labels">
        <Labels />
      </SidebarSection>

      <SidebarSection title="Development">
        <Development />
      </SidebarSection>
    </div>
  )
}
